<template>
  <div class="music-info" :class="[info ? '' : 'hide']">
    <div
      class="image"
      :style="{
        'background-image': `url(${info.pic || '/assets/song-default.png'})`,
      }"
      v-if="info"
    >
      <div
        class="site-image"
        :style="{ 'background-image': `url(${siteImage})` }"
        v-if="siteImage"
      ></div>
    </div>
    <div class="info" v-if="info">
      <div class="name" :title="info.name">{{ info.name }}</div>
      <div class="author" :title="info.author">{{ info.author }}</div>
      <div class="footer">
        <span class="iconfont icon-bofang" @click="play"></span>
        <span class="iconfont icon-xiazai" @click="download"></span>
      </div>
    </div>
    <loading :visible="loading" />
  </div>
</template>

<script>
const FileMap = new Map();

export default {
  props: {
    info: {
      type: Object,
    },
  },
  data() {
    return {
      detail: null,
      loading: false,
    };
  },
  computed: {
    siteImage() {
      let type = this.info?.type || this.detail?.type;
      return type ? `/assets/platform/${type}.png` : '';
    },
  },
  created() {
    if (this.info && this.info.needParse === false) {
      this.detail = this.info;
    }
  },
  methods: {
    async getFile(type) {
      let key = `${type}:${this.info.url}`;
      if (FileMap.get(key)) return FileMap.get(key);
      else {
        let blob = await (
          await fetch(
            `${
              this.$config.apiUrl
            }/ex/songparser/stream/file/${type}?url=${encodeURIComponent(
              this.info.url
            )}`
          )
        ).blob();
        FileMap.set(key, blob);
        return blob;
      }
    },
    async getSongDetail(u) {
      if (this.detail) return;
      let url = u || this.info.url;
      let { data, code } = await (
        await fetch(
          `${this.$config.apiUrl}/ex/songparser/url?url=${encodeURIComponent(
            url
          )}`
        )
      ).json();
      if (code == 0) {
        this.detail = data;
      } else {
        this.detail = {};
      }
    },
    async play() {
      this.loading = true;
      try {
        new Audio().play();
        await this.getSongDetail();
        if (!this.detail.url) {
          this.loading = false;
          return this.$toast.error('此歌曲无法播放');
        }
        this.$emit('play', this.detail);
        this.$store.commit('setCurrent', {
          ...this.detail,
          url: URL.createObjectURL(
            await this.getFile('song')
          ),
        });
      } catch (e) {
        await this.$toast.error('获取音频失败');
      }
      this.loading = false;
    },
    async download() {
      this.loading = true;
      try {
        await this.getSongDetail();
        let { name, author, pic, url, lrc, type } = this.detail;
        if (!url) {
          if (!lrc) {
            this.loading = false;
            return this.$toast.error('此歌曲无法获取音频、歌词等');
          }
          this.$toast.warn('此歌曲无音频可播放');
        }
        if (this.$opener.openerOrigin && window.opener) {
          this.$opener.send(
            { name, author, pic, url, lrc, type },
            'musicdownload'
          );
          this.loading = false;
          this.$toast.success('已提下载数据至前一个页面');
          return;
        }
        let fileName = `${name} - ${author}`.replace(/[\\\/:*?"<>\|]/g, '');
        let zip = new JSZip();
        if (pic) {
          if (pic.match(/^\/\//)) {
            pic = 'https:' + pic;
          }
          let picFile = await this.getFile('pic');
          zip.file(
            `pic.${await this.$file.getExtByFileOrUrl(picFile, pic)}`,
            picFile,
            {
              binary: true,
            }
          );
        }
        if (url) {
          if (url.match(/^\/\//)) {
            url = 'https:' + url;
          }
          let audio = await this.getFile('song');
          zip.file(
            `${fileName}.${await this.$file.getExtByFileOrUrl(audio, url)}`,
            audio,
            {
              binary: true,
            }
          );
        }
        if (lrc) {
          zip.file(`${fileName}.lrc`, lrc, { binary: false });
        }
        zip.generateAsync({ type: 'blob' }).then((file) => {
          this.$file.downloadBlob(`${fileName}.zip`, file);
        });
      } catch (e) {
        console.log(e);
        this.$toast.error('下载出错了');
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.music-info {
  display: inline-flex;
  background-color: #fff;
  height: 100px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  width: 200px;
  user-select: none;
  &.hide {
    background: transparent;
    box-shadow: none;
  }
  .image {
    width: 90px;
    height: 90px;
    margin: 5px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    .site-image {
      width: 16px;
      height: 16px;
      bottom: 5px;
      left: 5px;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: absolute;
    }
  }
  .info {
    height: 100px;
    width: 100px;
    text-align: left;
    padding: 5px 0 5px 0;
    position: relative;
    .name {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: lighter;
    }
    .author {
      font-size: 14px;
      color: #6b6b6b;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: lighter;
    }
    .footer {
      position: absolute;
      right: 5px;
      bottom: 5px;
      font-size: 16px;
      color: rgb(54, 54, 54);
      .iconfont {
        font-size: 16px;
        cursor: pointer;
        margin-right: 10px;
        font-weight: bolder;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .music-info {
    width: 100%;
    margin-right: 0 !important;
    .info {
      flex: auto;
    }
  }
}
</style>